import { FC } from "react"

export const ReadyForHaulageMarker: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="52"
    viewBox="-1.5 -1.5 51 67"
  >
    <path
      d="M24 0A23.94 23.94 0 0 0 0 24c0 17.6 20.1 36.6 22.4 38.7a2 2 0 0 0 3.2 0C27.9 60.6 48 41.6 48 24A23.94 23.94 0 0 0 24 0"
      fill="#ffffff"
      stroke="#76BEDB"
      strokeWidth="3"
    />
    <svg
      x="10"
      y="10"
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
        fill="#76BEDB"
      />
    </svg>
  </svg>
)
